<template>
	<i class="icon icon-administracao_cargos"></i>
</template>

<script>
export default {}
</script>